package one.healthium.cali.presentation.navigation.today

import com.arkivanov.decompose.ComponentContext
import one.healthium.insights.domain.models.ActionModel

class DefaultTodayComponent(
    componentContext: ComponentContext,
    private val onMealPlanClicked: (String) -> Unit,
    private val onNotificationsClicked: () -> Unit,
    private val onActionClicked: (ActionModel) -> Unit,
) : TodayComponent, ComponentContext by componentContext {
    override fun onMealPlanClicked(id: String) {
        onMealPlanClicked.invoke(id)
    }

    override fun onNotificationsClicked() {
        onNotificationsClicked.invoke()
    }

    override fun onActionClicked(action: ActionModel) {
        onActionClicked.invoke(action)
    }
}
